export const GET_STARTUP = 'GET_STARTUP';
export const SEARCH_STARTUP = 'SEARCH_STARTUP';